import AuthUserService from './AuthUserService';
import { NotificationManager } from 'react-notifications';

export class Util {
    constructor(module) {
        this.module = module ? module : 'shomoshtee';
        this.baseUrl = require('../app/config.json') && require('../app/config.json').baseUrl;
    }

    getBaseUrl() {
        return this.baseUrl;
    }

    getModule() {
        return this.module;
    }

    hideWait = function () {

    };

    showWait = function () {
        this.hideWait();
    };

    showNotificationMsg = function (msg, level = 'info', timeOut, callback, priority) {
        if (level !== 'error') {
            NotificationManager.listNotify.forEach(n => NotificationManager.remove({ id: n.id }));
        }

        timeOut = timeOut ? timeOut : 1500;

        switch (level) {
            case 'info':
                NotificationManager.info(msg, 'info', timeOut, callback, priority);
                break;
            case 'success':
                NotificationManager.success(msg, 'success', timeOut, callback, priority);
                break;
            case 'warning':
                NotificationManager.warning(msg, 'warning', timeOut, callback, priority);
                break;
            case 'error':
                NotificationManager.error(msg, 'error', 0, callback, priority);
                break;
            default:
                NotificationManager.info(msg, 'info', timeOut, callback, priority);
        }
    }
    
    hideNotificationMsg = function () {
        NotificationManager.listNotify.forEach(n => NotificationManager.remove({ id: n.id }));
    };

    hasException = function (res) {
        if (res.data && res.data.ResponseCode) {
            switch (res.data.ResponseCode) {
                case 'UNAUTHORIZED':
                    new AuthUserService().logOut();
                    window.location.href = '/';
                    return true;
                case 'APP_ERROR':
                case 'BAD_REQUEST':
                case 'NOT_FOUND':
                case 'NO_CONTENT':
                case 'INTERNAL_ERROR':
                case 'CONNECT_ERROR':
                case 'FAILURE':
                case 'SERVICE_UNAVAILABLE':
                case 'CONNECT_TIMEOUT':
                case 'VALIDATION':
                    if (res.data.Message) this.showNotificationMsg(res.data.Message, 'error');
                    return true;
                default:
                    return false;
            }
        }
        return false;
    };

    parseError = function (responseText) {
        if (typeof responseText === 'object') {
            let msg = '';
            responseText.forEach(value => {
                msg += `${value}`;
            });

            return msg;
        } else {
            let findex = responseText.indexOf('<title>');
            let sindex = responseText.indexOf('</title>');
            return responseText.substring(findex + 7, sindex).replace('924', '');
        }
    };

    errorCallback = function (error, handleException = true) {
        if (!handleException) throw error;

        if (error && (error.toString() === 'Network Error' || error.status === -1))
            this.showNotificationMsg('Server not found....', 'error');
        else if (error.data) this.showNotificationMsg(this.parseError(error.data), 'error');
        else this.showNotificationMsg('Internal server error....', 'error');
    };
}
